import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PreApprovalReadDetails from "./component";

const mapStateToProps = ({
    preApprovalLoan: {
        financeData,
        inHouseFinanceEligibilityFinance,
        maxLoanAmount,
        financeQuotes,
        bestInterestRate,
        comparisonRate
    }
}) => ({
    financeData,
    maxLoanAmount,
    financeQuotes,
    inHouseFinanceEligibilityFinance,
    bestInterestRate,
    comparisonRate
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PreApprovalReadDetails);
